// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { WorkflowAnswerOptionCreateUpdateRequest } from './workflowAnswerOptionCreateUpdateRequest';

/**
 * Serializer for validating and creating items Workflow/Smart workflows.
 * @see #/components/schemas/WorkflowCreateItemRequest - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowCreateItemRequest {
    /**
     * The name of the Item Questionnaire.
     *
     */
    title: string;
    required?: boolean;
    /**
     * The description of the Item Questionnaire.
     *
     */
    description?: string | null;
    /**
     * The type of Item Questionnaire.
     *
     */
    item_type: string;
    /**
     * The answer options items of Workflow.
     *
     */
    answer_options?: Array<WorkflowAnswerOptionCreateUpdateRequest>;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowCreateItemRequest
 */
export namespace WorkflowCreateItemRequest {
    /**
     * WorkflowCreateItemRequest Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The name of the Item Questionnaire.
         * @type string (`dataFormat` is missing)
         */
        title: string;
        required?: boolean;
        /**
         * The description of the Item Questionnaire.
         * @type string (`dataFormat` is missing)
         */
        description?: string | null;
        /**
         * The type of Item Questionnaire.
         * @type string (`dataFormat` is missing)
         */
        itemType: string;
        /**
         * The answer options items of Workflow.
         * @type Array<WorkflowAnswerOptionCreateUpdateRequest> (`dataFormat` is missing)
         */
        @Type(() => WorkflowAnswerOptionCreateUpdateRequest.Model)
        answerOptions?: Array<WorkflowAnswerOptionCreateUpdateRequest.Model>;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowCreateItemRequest DTO
     * Transforms WorkflowCreateItemRequest model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowCreateItemRequest model */
        static toModel(obj: WorkflowCreateItemRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowCreateItemRequest model */
        static toApi(obj: Model): WorkflowCreateItemRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowCreateItemRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
